export default __webpack_public_path__ + "static/media/FR.674fb399.svg";